export const getGraphQLErrorMessage = (err) => {
  const gq = err?.graphQLErrors?.[0];
  return (
    gq?.extensions?.message ||
    gq?.message ||
    err?.message ||
    "Something went wrong."
  );
};